module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-btn-panel'],
    style: ({
      'background-color': this.bgColor
    }),
    attrs: {
      "accessible": true,
      "aria-label": _vm.text,
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "btn-group-wrap weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.btnGroup), function(text, index) {
    return _c('p', {
      key: index,
      staticClass: " weex-el weex-text",
      class: [
        'btn-text',
        !_vm.disabled && _vm.pattern === 'text' &&
        ("dof-text-highlight-" + _vm.type)
      ],
      style: ([index < _vm.btnGroup.length - 1 ? _vm._processExclusiveStyle(_vm.verticalLineStyle, 75, 'text') : _vm._processExclusiveStyle('', 75, 'text'), _vm._processExclusiveStyle(_vm.textStyle, 75, 'text'), index == _vm.selectIndex ? _vm._processExclusiveStyle(_vm.textBtnStyle, 75, 'text') : _vm._processExclusiveStyle('', 75, 'text')]),
      attrs: {
        "data-index": index,
        "weex-type": "text",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.onTextClicked(index)
        }
      }
    }, [_vm._v(_vm._s(text))])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-702a34c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-702a34c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-button-group/index.vue
// module id = 625
// module chunks = 0 1